// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

import ProjectsController from "./projects_controller"
application.register("projects", ProjectsController)

import BlocksController from "./blocks_controller"
application.register("blocks", BlocksController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import SectionsController from "./sections_controller"
application.register("sections", SectionsController)
